export enum HPSummarySection {
  TotalBpPitches = 'hitters.total-bp-pitches',
  TotalPitchTypes = 'hitters.total-pitch-types-faced',
  KeyMetricAverages = 'hitters.key-metric-averages',
  // HitQualityProfile = 'hitters.hit-quality-profile',
  // ZoneMetrics = 'hitters.zone-metrics',
  HitSprayChart = 'hitters.hit-spray-chart',
}
